import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getPayrollBusinessRulesSchema = () =>
  call(websocketFetch, 'set_payroll_business_rules/schema/request');
